module.exports = __webpack_public_path__ + "posture/static/img/high_low_shoulder_right.aa267a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/abnormal/high_low_shoulder_right.png
// module id = ihJy
// module chunks = 1